import React from "react";

const RegionalGrowthBreakdownSubtitle: React.FC = () => {
    return (
        <>
            See your regional revenue growth breakdown for the last twelve months. Are some regions underperforming, and
            can some be exploited further? Which ones need attention?
        </>
    );
};

export default RegionalGrowthBreakdownSubtitle;
